export default __webpack_public_path__ + "static/cheap_diagonal_fabric-f4cb81306445dac71447b5294853cfbd.png";